<template>
    <b-row>
        <ul>
            <app-list-lecturer :key="text.id1" v-for="text in texts" :text="text"></app-list-lecturer>
        </ul>
    </b-row>
</template>
<script>
    import {texts} from "../../data/main";
    import ListLecturer from "./ListLecturer";
    export default {
        name: "ListLectures",
        data() {
            return {
                texts,
            }
        },
        components: {
            appListLecturer: ListLecturer,
        }
    }
</script>
<style scoped>
    ul li {
        font-size: 11px;
        line-height: 1.4rem;
        padding-right: 12px;
    }
    ul {
        /*padding-right: 12px;*/
        list-style: none;
    }
</style>